import { defineRecipe } from "@chakra-ui/react";

export const radioGroupItemText = defineRecipe({
  base: {
    fontWeight: 600,
    fontSize: 16,
    w: "100%",
  },
});
